export default {
    parts: [
        'container',
        'title',
        'subtitle',
        'toolbar',
        'toolbarLeft',
        'toolbarCenter',
        'showMoreContainer',
        'showMoreButton',
        'showPreviousContainer',
        'grid',
        'errorMessage'
    ],
    baseStyle: {
        container: {
            paddingX: {base: '16px', lg: '24px'},
            paddingTop: {base: '24px', lg: '36px'},
            paddingBottom: '64px'
        },
        title: {
            color: 'black',
            fontFamily: 'heading',
            fontSize: {base: '16px', lg: '20px'},
            fontWeight: 'bold',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            margin: '0 0 16px',
            padding: 0,
            textTransform: 'uppercase',
            textAlign: 'center'
        },
        subtitle: {
            color: 'black',
            fontSize: '14px',
            lineHeight: 1.2,
            margin: {base: '0 0 36px', lg: '0 0 56px'},
            textAlign: 'center',
            '& a': {fontWeight: 'bold'}
        },
        toolbar: {
            display: {base: 'flex', lg: 'grid'},
            gridTemplateColumns: {lg: '1fr auto 1fr'},
            alignItems: 'center',
            justifyContent: {base: 'flex-start', lg: 'normal'},
            columnGap: {base: '12px', lg: 0},
            marginBottom: '16px'
        },
        toolbarLeft: {justifySelf: 'start'},
        toolbarCenter: {
            justifySelf: 'center',
            marginLeft: {base: 'auto', lg: 0}
        },
        showMoreContainer: {marginTop: {base: 12, lg: 16}},
        showMoreButton: {width: {base: '100%'}, maxWidth: {base: '100%', lg: '342px'}},
        showPreviousContainer: {marginTop: '1.75rem', marginBottom: '1.75rem'},
        grid: {
            columnGap: '8px',
            rowGap: {base: '8px', lg: '32.06px'}
        },
        errorMessage: {marginTop: '24px', textAlign: 'center'}
    }
}
